import Infothek from './main';
import resultTemplate from '../../templates/partials/organisms/ST06_InfothekNeuigkeiten/vue-result-template.hbs';
import selectedFilterTemplate from '../../templates/partials/organisms/ST06_InfothekNeuigkeiten/vue-selected-filter-template.hbs';

class BfvInfothekNeuigkeiten extends Infothek {
  constructor(options = {}) {
    Object.assign(options, {
      vue: {
        results: {
          template: resultTemplate,
          el: '#bfv-infothek-neuigkeiten__results',
        },
        selectedFilter: {
          template: selectedFilterTemplate,
          el: '#bfv-infothek-neuigkeiten__selected-filter',
        },
      },
    });
    super(options);

    this.apiConfig = Object.assign(this.apiConfig, {
      route: this.$root.getAttribute('data-api-route'),
    });
  }

  dataLoaded() {
    this.vueResultComponent.updateData(this.data);
    this.updateTotalHits();
  }

  init() {
    this.loadData();

    this.$sortDropdown = this.$root.querySelector('.js-sort-dropdown-wrapper .dropdown > select');

    this.$sortDropdown.addEventListener('change', () => {
      this.apiConfig.params.sortType = this.$sortDropdown.options[this.$sortDropdown.selectedIndex].value;
      this.apiConfig.params.size = this.pageItemCount;
      this.apiConfig.params.from = 0;
      this.loadData();
    });
  }
}

export default BfvInfothekNeuigkeiten;
